<div id="header">

  @if (user) {
    <div class="greeting-bar">
      <h1>{{ activeHeading ? activeHeading : ('Willkommen '+ user.name +'!') }}</h1>
      <app-quick-nav></app-quick-nav>
    </div>
  }
</div>
